import Reveal from "@stimulus-components/reveal"

/**
 * Shows `item` targets when `source` text matches a `keywords` entry.
 * Observes `source` via MutationObserver (for RubyUI SelectValue spans).
 *
 * Optional: `emptyLabel` (treat as blank), `context` + `initialFallback` (first paint).
 * Set `data-keyword-reveal-hidden-class="tw-hidden"` when using Tailwind visibility.
 */
export default class extends Reveal {
  static targets = ["source", "context", "item"]
  static values = {
    keywords: Array,
    initialFallback: Boolean,
    emptyLabel: { type: String, default: "" }
  }

  connect() {
    super.connect()
    this.#observeSource()
    this.#sync()
  }

  disconnect() {
    this.sourceObserver?.disconnect()
    super.disconnect()
  }

  #observeSource() {
    if (!this.hasSourceTarget) return

    this.sourceObserver = new MutationObserver(() => this.#sync())
    this.sourceObserver.observe(this.sourceTarget, {
      subtree: true,
      characterData: true,
      childList: true
    })
  }

  #sync() {
    const label = this.hasSourceTarget ? this.sourceTarget.textContent?.trim() || "" : ""
    const blank = !label || label === this.emptyLabelValue
    const matched = !blank && this.keywordsValue.includes(label)
    const fallback =
      this.initialFallbackValue && this.hasContextTarget && Boolean(this.contextTarget.value?.trim())

    this.#setVisible(matched || fallback)
  }

  #setVisible(visible) {
    visible ? this.show() : this.hide()

    this.itemTargets.forEach((el) => {
      el.querySelectorAll("input").forEach((input) => {
        input.required = visible
      })
    })
  }
}
